import { withToastManager } from 'react-toast-notifications';
import JuxtaPostContainer from "./JuxtaPostContainer"

const JuxtaPostWithToastsContainer = withToastManager(JuxtaPostContainer);

export default JuxtaPostWithToastsContainer;



// WEBPACK FOOTER //
// ./src/containers/JuxtaPostWithToastsContainer.js